module.exports = "pegasus_template/assets/email1-image-1.png";